import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol viewBox=\"0 0 24 25\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.33301 4.77246L19.7264 19.1659L18.6658 20.2265L4.27235 5.83312L5.33301 4.77246Z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.7272 5.83312L5.33376 20.2265L4.2731 19.1659L18.6665 4.77246L19.7272 5.83312Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol